// Checklist de booleanos en grilla responsive — extraído de Formulario038.tsx
// (038 fue el primer consumidor) al agregar un 2° y 3° consumidor real
// (Formulario028A.tsx, y luego 028B/028C) — mismo criterio que ya usa el
// proyecto: generalizar recién con el 2°/3er caso real, no antes.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

export interface ChecklistGridProps {
  readonly claves: readonly string[];
  readonly prefijoI18n: string;
  readonly prefijoId: string;
  readonly valores: Record<string, boolean>;
  readonly onChange: (v: Record<string, boolean>) => void;
}

export function ChecklistGrid({ claves, prefijoI18n, prefijoId, valores, onChange }: ChecklistGridProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
      {claves.map((clave) => (
        <div key={clave} className="flex items-center gap-2">
          <Checkbox id={`${prefijoId}-${clave}`} checked={valores[clave] === true} onCheckedChange={(v) => onChange({ ...valores, [clave]: v === true })} />
          <Label htmlFor={`${prefijoId}-${clave}`} className="text-sm font-normal">
            {t(`${prefijoI18n}.${clave}`)}
          </Label>
        </div>
      ))}
    </div>
  );
}
